/**
 * Laatst gebruikt — bij welke draaidag ging een exemplaar het laatst mee?
 *
 * Wiki-feedback Robin (6 okt 2026): "Mocht materiaal niet vindbaar zijn in het magazijn
 * (kwijt), wil je zien bij welke draaidag het laatst is gebruikt." De reserveringen per
 * exemplaar hadden we al; dit kiest daaruit de meest recente die al begonnen is.
 *
 * @param {Array<{start?: string, eind?: string}>} reserveringen  zoals getMaterialReservations ze geeft
 * @param {string} vandaag  YYYY-MM-DD
 * @returns {object|null}  de reservering + `lopend` (vandaag valt erbinnen), of null
 */
export function laatsteGebruik(reserveringen, vandaag) {
  const begonnen = (reserveringen || []).filter((r) => r && r.start && r.start.slice(0, 10) <= vandaag);
  if (begonnen.length === 0) return null;
  const nieuwste = [...begonnen].sort((a, b) => b.start.localeCompare(a.start))[0];
  const eind = (nieuwste.eind || nieuwste.start).slice(0, 10);
  return { ...nieuwste, lopend: eind >= vandaag };
}

/** '2026-10-03' → 'za 3 okt 2026'; onleesbare invoer komt ongewijzigd terug. */
export function datumKort(iso) {
  if (!iso) return '';
  const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
}
